import React from 'react';
import styles from './ListingActionBar.module.css';

const ListingActionBar = ({
    children,
    leftSection,
    rightSection,
    className = ''
}) => {
    return (
        <div className={`${styles.actionBar} ${className}`}>
            {leftSection && <div className={styles.leftGroup}>{leftSection}</div>}
            {children && <div className={styles.centerGroup}>{children}</div>}
            {rightSection && <div className={styles.rightGroup}>{rightSection}</div>}
        </div>
    );
};

export default ListingActionBar;
